import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OnboardTenantMutationVariables = Types.Exact<{
  input: Types.OnboardTenantInput;
}>;


export type OnboardTenantMutation = { __typename?: 'RootMutationType', onboardTenant?: { __typename?: 'ViewerResult', viewer?: { __typename?: 'User', id: string, email?: string | null, emailVerified?: boolean | null, onboardingStatus: Types.OnboardingStatus, role: string, tenantCount: number, activeTenant?: { __typename?: 'Tenant', id: string, databaseId: any, commerceActivated: boolean, storyCount?: number | null, name?: string | null, features: Array<Types.PlanFeature> } | null, member?: { __typename?: 'Member', id: string, role: string, displayName?: string | null } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const OnboardTenantDocument = gql`
    mutation onboardTenant($input: OnboardTenantInput!) {
  onboardTenant(input: $input) {
    viewer {
      id
      email
      emailVerified
      onboardingStatus
      role
      tenantCount
      activeTenant {
        id
        databaseId
        commerceActivated
        storyCount
        name
        features
      }
      member {
        id
        role
        displayName
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type OnboardTenantMutationFn = Apollo.MutationFunction<OnboardTenantMutation, OnboardTenantMutationVariables>;

/**
 * __useOnboardTenantMutation__
 *
 * To run a mutation, you first call `useOnboardTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardTenantMutation, { data, loading, error }] = useOnboardTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardTenantMutation(baseOptions?: Apollo.MutationHookOptions<OnboardTenantMutation, OnboardTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardTenantMutation, OnboardTenantMutationVariables>(OnboardTenantDocument, options);
      }
export type OnboardTenantMutationHookResult = ReturnType<typeof useOnboardTenantMutation>;
export type OnboardTenantMutationResult = Apollo.MutationResult<OnboardTenantMutation>;
export type OnboardTenantMutationOptions = Apollo.BaseMutationOptions<OnboardTenantMutation, OnboardTenantMutationVariables>;